import axios from "../axiosInstance";
import { GetMailchimpTemplatesResponse } from "./types";

export const getMailchimpTemplates =
  async (): Promise<GetMailchimpTemplatesResponse> => {
    const response = await axios.get<GetMailchimpTemplatesResponse>(
      "/api/private/mailchimp-templates",
    );
    return response.data;
  };
